var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseButtonRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#0A161F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2513 10.7487C11.8364 10.3338 11.1636 10.3338 10.7487 10.7487C10.3338 11.1636 10.3338 11.8364 10.7487 12.2513L16.4974 18L10.7487 23.7487C10.3338 24.1636 10.3338 24.8364 10.7487 25.2513C11.1636 25.6662 11.8364 25.6662 12.2513 25.2513L18 19.5026L23.7487 25.2513C24.1636 25.6662 24.8364 25.6662 25.2513 25.2513C25.6662 24.8364 25.6662 24.1636 25.2513 23.7487L19.5026 18L25.2513 12.2513C25.6662 11.8364 25.6662 11.1636 25.2513 10.7487C24.8364 10.3338 24.1636 10.3338 23.7487 10.7487L18 16.4974L12.2513 10.7487Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButtonRound);
export default __webpack_public_path__ + "static/media/close-button-round.db9b8cea82b407d9407e4dc7c3a370a3.svg";
export { ForwardRef as ReactComponent };